export const defaultLang = "fr";
export const supportedLangs = ['en','fr'];